import React, { useEffect, Fragment, useState, useCallback } from 'react';
import {
    Row,
    Col,
    Card,
    Button,
    ListGroup,
    ListGroupItem,
    Container
} from 'reactstrap';

import UserRelationGroupStatuses from '../../../../../enums/UserRelationGroupStatuses';
import UserRoles from '../../../../../enums/UserRoles';
import api from '../../../../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../../../../Context/Auth/AuthContext';
import InputMask from 'react-input-mask';

export default function CoordinatorsList({
    id,
    activeTab,
    type,
    filter,
    newUser,
}) {
    const { toggleLoading } = useAuth();
    const [coordinatorsData, setCoordinatorsData] = useState([]);

    const [lastId, setLastId] = useState(null);

    const loadCoordinators = useCallback(() => {
        toggleLoading(true);
        api.post(`/ro.team.listCoordinatorsGroup/${id.id}`)
            .then((response) => {
                setCoordinatorsData(response.data.items);
                setLastId(response.data.lastId);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
            });
    }, [id, toggleLoading, setLastId]);

    const loadMore = useCallback(() => {
        toggleLoading(true);
        api.post(`/ro.team.listCoordinatorsGroup/${id.id}`, { lastId })
            .then((response) => {
                setCoordinatorsData([...coordinatorsData, ...response.data.items]);
                setLastId(response.data.lastId);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
            });
    }, [coordinatorsData, toggleLoading, id, setLastId, lastId]);

    useEffect(() => {
        if (activeTab === UserRoles.COORDINATOR.toString()) {
            loadCoordinators();
        }
        if (newUser === UserRoles.COORDINATOR.toString()) {
            loadCoordinators();
        }
    }, [activeTab, newUser, loadCoordinators]);

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col lg="12">
                        <Card className="main-card mb-3">
                            <ListGroup flush className="users-list">
                                {coordinatorsData &&
                                    coordinatorsData.map(
                                        (member) =>
                                             (
                                                <ListGroupItem key={member.id}>
                                                    <div className="widget-content p-0">
                                                        <div className="widget-content-wrapper">
                                                            <div className="widget-content-left mr-3">
                                                                <div className="placeholder-avatar">
                                                                    {member.name
                                                                        ? member.name.charAt(
                                                                              0
                                                                          )
                                                                        : member.email.charAt(
                                                                              0
                                                                          )}
                                                                </div>
                                                            </div>
                                                            <div className="widget-content-left">
                                                                <div className="widget-heading">
                                                                    {member.name &&
                                                                        member.name}
                                                                    {member.isOwner && (
                                                                        <div className="mb-2 ml-2 badge badge-info">Group Owner</div>
                                                                    )}
                                                                </div>
                                                                <div className="widget-subheading">
                                                                    {
                                                                        member.email
                                                                    }
                                                                </div>
                                                                <div className="widget-subheading">
                                                                    {member.phone && (
                                                                        <InputMask
                                                                            mask="(999) 999-9999"
                                                                            disabled={true}
                                                                            defaultValue={member.phone}
                                                                            className="textInputChange"
                                                                        />
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="widget-content-right">
                                                                {member.status
                                                                    .code ===
                                                                    UserRelationGroupStatuses.INVITED_BY_PARENT && (
                                                                    <div className="mb-2 mr-2 badge badge-warning">
                                                                        Waiting
                                                                        for
                                                                        acceptance
                                                                    </div>
                                                                )}

                                                                {member.status
                                                                    .code ===
                                                                    UserRelationGroupStatuses.SUSPENDED && (
                                                                    <div className="mb-2 mr-2 badge badge-info">
                                                                        Inactive
                                                                    </div>
                                                                )}

                                                                {member.status
                                                                    .code ===
                                                                    UserRelationGroupStatuses.REJECTED_BY_CHILD && (
                                                                    <div className="mb-2 mr-2 badge badge-info">
                                                                        Declined
                                                                    </div>
                                                                )}

                                                            </div>
                                                        </div>
                                                    </div>
                                                </ListGroupItem>
                                            )
                                    )}
                            </ListGroup>
                        </Card>

                        {lastId !== null && (
                            <div className="text-center">
                                <Button
                                    className="btn-wide mb-2 mr-2"
                                    size="md"
                                    color="info"
                                    onClick={loadMore}
                                >
                                    Load more
                                </Button>
                            </div>
                        )}

                    </Col>
                </Row>

            </Container>
        </Fragment>
    );
}
